<template>
  <div>
    <div class="md-layout login">
      <div class="md-layout-item">
        <img alt="Vue logo" src="../assets/logo.svg" />
        <div class="login-btn-group">
          <md-button v-if="isFaculty()" @click="start" class="md-raised md-accent start-btn">
            <md-icon>add_box</md-icon>
            <span>Start Assessment</span>
          </md-button>
          <md-button
            v-if="isFaculty() || isStudent() || isGroupLeader()"
            @click="view"
            class="md-raised md-accent view-btn"
          >
            <md-icon>list_alt</md-icon>
            <span>View Assessment</span>
          </md-button>
          <md-button @click="logout" class="md-raised md-accent logout-btn">
            <md-icon>exit_to_app</md-icon>
            <span>Log Out</span>
          </md-button>
        </div>
        <div class="md-layout">
          <div
            class="md-layout-item p10 copyright"
          >© UT Health San Antonio School of Dentistry All Right Reserved</div>
        </div>
      </div>
      <div class="md-layout login p40" style="display:none;">
        <div class="md-layout-item text-left">
          <md-checkbox v-model="rememberMe">Remember me</md-checkbox>
        </div>
        <div class="md-layout-item forgot-password">
          <a href="#">Forgot password?</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import LoginUser from "../graphql/LoginUser.gql";
import RoleMixin from './RoleMixin.vue';
export default {
  mixins: [RoleMixin],
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      rememberMe: false
    };
  },
  methods: {
    start() {
      window.location.href = "/dashboard/assessments#create";
    },
    view() {
      window.location.href = "/dashboard/assessments";
    },
    logout() {
      window.localStorage.removeItem("apollo-token");
      window.location.href = "/";
    }
  }
};
</script>

<style lang="scss" scoped>
.forgot-password {
  text-align: right;
  a {
    color: #fff !important;
    padding: 13px 0;
    display: inline-block;
  }
}
.copyright {
  color: #fff;
  font-size: 12px;
  position: fixed;
  text-align: center;
  bottom: 0;
  left: 0;
  width: 100%;
}
.p10 {
  padding: 10px;
}
.p40 {
  padding: 40px 16px;
}
.login {
  margin: 0 auto;
  max-width: 320px;
  .md-button {
    min-width: 220px;
    .md-ripple {
      border-radius: 0px;
      padding-left: 20px;
      padding-right: 20px;
      justify-content: flex-start;
    }
    margin: 10px;
    font-weight: 600;
  }
  .login-btn-group {
    display: flex;
    flex-direction: column;
    .start-btn {
      .md-ripple {
        justify-content: flex-start;
      }
    }
    .md-menu {
      .md-button {
        .md-icon {
          color: #fff;
        }
        min-width: 50px;
        &:hover::before {
          border-radius: 0px;
        }
        border-radius: 0px 30px 30px 0px;
        background-color: #9c0100;
      }
    }
  }
}
form {
  padding-top: 30px;
  text-align: left;
  label {
    margin-left: 30px;
    font-weight: 700;
    color: #fff;
  }
}
</style>